import * as _ from "lodash";
import { Utilities } from "../../shared/utilities";
import { INotificationMessage, INotificationMessageViewedStatus } from "../components/NotificationMessageNotifier";
import { IAppReducerAction } from "../shared/model";

export const getNotificationMessages = async (dispatch: React.Dispatch<IAppReducerAction>, notificationStorageKey: string) => {
    const updateViewedStatusFromLocalStorage = (messages: INotificationMessage[]): INotificationMessage[] | undefined => {
        if (typeof (Storage) !== "undefined") {
            const item = localStorage.getItem(notificationStorageKey);
            const localStoreMessages: INotificationMessageViewedStatus[] =
                item != null ? JSON.parse(item) : [];

            const updatedMessages = (messages || []).map((msg) => {
                const localMessage = localStoreMessages.find((lmsg) => lmsg.id === msg.id);
                if (localMessage != null) {
                    msg.viewed = localMessage.viewed;
                }

                return msg;
            });
            return updatedMessages;
        }
    };
    const fetchPackages = async () => {
        try {
            const res: INotificationMessage[] = await Utilities.getFetch("api/navigation/notification");
            // the information if a comment has been viewed/dismissed is stored in the local db, this is updated to the state when the data is fetched from the server
            const messages = updateViewedStatusFromLocalStorage(res) || [];
            dispatch({ type: "SET_NOTIFICATION_MESSAGES", notificationMessages: messages });
        } catch (e) {
            console.error("Unable to retrive notification message: " + e);
        }
    };
    fetchPackages();
};

export const getLastReadNotification = (dispatch: React.Dispatch<IAppReducerAction>, releaseNoteStorageKey: string) => {
    const fnn: { lastReadVersion: string } = JSON.parse(localStorage.getItem(releaseNoteStorageKey) as string);
    if (!_.isEmpty(fnn)) {
        dispatch({ type: "SET_LAST_READ_VERSION", lastReadVersion: fnn.lastReadVersion });
    } else {
        setLastReadVersion(dispatch, null, releaseNoteStorageKey);
    }
};

export const setLastReadVersion = async (dispatch: React.Dispatch<IAppReducerAction>, lastReadVersion: string | null, releaseNoteStorageKey: string) => {
    localStorage.setItem(releaseNoteStorageKey, JSON.stringify({
        lastReadVersion: lastReadVersion
    }));
    dispatch({ type: "SET_LAST_READ_VERSION", lastReadVersion: lastReadVersion });
};
